import { TableRecord } from '@common/types';
import classNames from 'classnames';

export const setChildWithStyles = (value: string | number, record: TableRecord) => {
  const className = classNames({ 'set-child-item': !record.children });

  return <span className={className}>{value}</span>;
};
